import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect } from 'react';
import { I18nProvider } from '@lingui/react';
import Layout from './navigation/layout/layout';
import useI18n from '../../hooks/i18n-hook';
import likesContext from '../../contexts/likes-context';
import useLikes from '../../hooks/likes-hook';
import useLikesQuery from '../../hooks/likes-query-hook';

var AppContainer = function AppContainer(_ref) {
  var children = _ref.children,
      location = _ref.location,
      pageContext = _ref.pageContext,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "location", "pageContext"]);

  var pathname = location.pathname;
  var curLang = pageContext.langKey || pageContext.language; // set up i18n stuff

  var _useI18n = useI18n(curLang),
      i18n = _useI18n.i18n; // set likes value and function as global context


  var _useLikes = useLikes(),
      allLikes = _useLikes.allLikes,
      hasLikes = _useLikes.hasLikes,
      setInitialLikesHandler = _useLikes.setInitialLikesHandler,
      setLikesHandler = _useLikes.setLikesHandler,
      checkLikesHandler = _useLikes.checkLikesHandler,
      updateLikesHandler = _useLikes.updateLikesHandler;

  var initialData = useLikesQuery(); // set initial values of likes at the first render

  useEffect(function () {
    setInitialLikesHandler(initialData);
  }, []); // Merge props, and pathname (inefficient but legible and maintainable <-- destructure & merge)

  var newProps = Object.assign({}, props, {
    pathname: pathname
  });
  return /*#__PURE__*/React.createElement(I18nProvider, {
    i18n: i18n
  }, /*#__PURE__*/React.createElement(likesContext.Provider, {
    value: {
      allLikes: allLikes,
      hasLikes: hasLikes,
      setUpdatedLikes: setLikesHandler,
      checkLikes: checkLikesHandler,
      updateLikes: updateLikesHandler
    }
  }, /*#__PURE__*/React.createElement(Layout, newProps, children)));
};

export default AppContainer;